import {
  useQuery as ApolloUseQuery,
  useLazyQuery as ApolloUseLazyQuery,
  useMutation as ApolloUseMutation,
} from '@apollo/client';
import { useEffect } from 'react';
import useGlobalContext from './useGlobalContext';
import useUser from './useUser';

// This hook EXTENDS the apollo useQuery to use ErrorBoundary
export const useQuery = (query, options) => {
  const { data, loading, error, ...rest } = ApolloUseQuery(query, {
    fetchPolicy: 'cache-and-network',
    ...options,
  }); // Apollos original hook

  if (error?.message === 'Unauthorized') {
    throw error;
  }

  return {
    data,
    loading: loading && !data,
    updating: loading && !!data,
    fetching: loading,
    error,
    ...rest,
  };
};

export const useLazyQuery = (query, options) => {
  const { isSuperUser } = useUser();
  const { message } = useGlobalContext();
  const [getResult, result] = ApolloUseLazyQuery(query, {
    fetchPolicy: 'cache-and-network',
    ...options,
  });

  useEffect(() => {
    if (result.error) {
      if (isSuperUser) {
        message.error(result.error.message);
      } else {
        message.error('Something went wrong. Please try again later.');
      }
    }
  }, [result.error]);

  return [getResult, result];
};

export const useMutation = (query, options) => {
  const [handleMutation, result] = ApolloUseMutation(query, options);

  // React <ErrorBoundary> Catches this error!
  // if (result.error) { throw result.error; }

  return [handleMutation, result];
};
